export const getSecondsBetweenTwoDates = (from: Date, to: Date) => {
    let TotalSeconds = Math.ceil((to.getTime() - from.getTime()) / 1000);
    return TotalSeconds;
};

export const getDaysBetweenTwoDates = (from: Date, to: Date) => {
    let TotalSeconds = Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));
    return TotalSeconds;
};
